<div class="flex items-center gap-1">
  @for (star of stars; track star) {
    <button
      type="button" class="cursor-pointer p-1 transition-transform active:scale-95 border-none bg-transparent"
      (mouseenter)="setHover(star)"
      (mouseleave)="setHover(null)"
      (click)="selectStar(star)">

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="w-8 h-8 transition-colors duration-150"
        [class.text-amber-400]="(hoveredValue !== null ? star <= hoveredValue : star <= value)"
        [class.text-gray-300]="(hoveredValue !== null ? star > hoveredValue : star > value)">
        <path
          fill="currentColor"
          d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
      </svg>
    </button>
  }
</div>
